import React from 'react';
import { RoutePermittedRole } from '../../constants/AppEnums';
const Realty = React.lazy(() => import('../../../modules/realty'));
const CreateRealty = React.lazy(() => import('../../../modules/realty/Create'));
const UpdateRealty = React.lazy(() => import('../../../modules/realty/Update'));
export const realtyRouteConfig = [
  {
    permittedRole: [RoutePermittedRole.Admin, RoutePermittedRole.Seller],
    path: '/realty',
    element: <Realty />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin, RoutePermittedRole.Seller],
    path: '/realty/create',
    element: <CreateRealty />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin, RoutePermittedRole.Seller],
    path: '/realty/:id/update',
    element: <UpdateRealty />,
  }
];
